export default __webpack_public_path__ + "static/media/logo.66d51c4b.png";